/**
 * Превью ролика на доске.
 *
 * В прототипе превью брались из демо-картинок. Здесь кадр снимается прямо в
 * браузере при сдаче версии и кладётся рядом с видео: без него карточка на
 * проверке была бы пустой плашкой, а тянуть ради превью весь ролик нельзя.
 */

/** Нейтральная заглушка 9:16 — для задач, у которых версий ещё нет. */
export const PLACEHOLDER_POSTER =
  "data:image/svg+xml;utf8," +
  encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" width="360" height="640" viewBox="0 0 360 640">` +
      `<defs><linearGradient id="g" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#e5e5e5"/><stop offset="1" stop-color="#d4d4d4"/></linearGradient></defs>` +
      `<rect width="360" height="640" fill="url(#g)"/>` +
      `<path d="M160 290 L208 320 L160 350 Z" fill="#a3a3a3"/>` +
      `</svg>`,
  );

/**
 * Кадр из видеофайла, JPEG 360×640. Берём не самый первый кадр — он часто
 * чёрный, — а через секунду или на десятой части ролика, что раньше.
 * Не вышло (кодек браузеру не по зубам) — `null`, версия уйдёт без превью.
 */
export function captureFrame(file: File, timeoutMs = 8000): Promise<Blob | null> {
  return new Promise((resolve) => {
    const url = URL.createObjectURL(file);
    const video = document.createElement("video");
    let settled = false;
    const done = (blob: Blob | null) => {
      if (settled) return;
      settled = true;
      URL.revokeObjectURL(url);
      video.removeAttribute("src");
      video.load();
      resolve(blob);
    };
    const timer = window.setTimeout(() => done(null), timeoutMs);

    video.muted = true;
    video.playsInline = true;
    video.preload = "auto";
    video.onloadedmetadata = () => {
      const d = Number.isFinite(video.duration) ? video.duration : 0;
      video.currentTime = Math.min(1, d / 10 || 0);
    };
    video.onseeked = () => {
      const w = 360;
      const h = 640;
      const canvas = document.createElement("canvas");
      canvas.width = w;
      canvas.height = h;
      const ctx = canvas.getContext("2d");
      if (!ctx || !video.videoWidth) {
        window.clearTimeout(timer);
        done(null);
        return;
      }
      // Обрезка «по центру» под 9:16, как object-cover
      const scale = Math.max(w / video.videoWidth, h / video.videoHeight);
      const sw = w / scale;
      const sh = h / scale;
      ctx.drawImage(video, (video.videoWidth - sw) / 2, (video.videoHeight - sh) / 2, sw, sh, 0, 0, w, h);
      canvas.toBlob((blob) => {
        window.clearTimeout(timer);
        done(blob);
      }, "image/jpeg", 0.82);
    };
    video.onerror = () => {
      window.clearTimeout(timer);
      done(null);
    };
    video.src = url;
  });
}
